module.exports = __webpack_public_path__ + "img/other_06.e3a2a90a.jpg";